
var id = "secret";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"secret\">\n<style type=\"text/css\">\n\t#secret .st0{fill:#3379C8;}\n</style>\n<path class=\"st0\" d=\"M11,6.6H5c-0.2,0-0.3,0.1-0.3,0.3v4.4c0,0.2,0.1,0.3,0.3,0.3h6c0.2,0,0.3-0.1,0.3-0.3V6.9\n\tC11.3,6.7,11.2,6.6,11,6.6z M8.2,9.1C8.2,9.2,8.2,9.2,8.2,9.1l0,0.6C8.2,9.9,8.1,10,8,10c-0.1,0-0.2-0.1-0.2-0.2V9.2\n\tc0,0,0-0.1,0-0.1C7.7,9.1,7.5,8.9,7.5,8.7c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5C8.5,8.9,8.4,9.1,8.2,9.1z\" />\n<path class=\"st0\" d=\"M8,3.8c-1.3,0-2.4,1-2.5,2.3h5C10.4,4.8,9.3,3.8,8,3.8z\" />\n<path class=\"st0\" d=\"M8,1C4.2,1,1,4.2,1,8c0,3.8,3.1,7,7,7c3.8,0,7-3.1,7-7C15,4.2,11.8,1,8,1z M11.8,11.3c0,0.4-0.3,0.7-0.7,0.7\n\tl-6,0c-0.4,0-0.7-0.3-0.7-0.7V6.9c0-0.4,0.3-0.7,0.7-0.7h0.1C5.2,4.6,6.5,3.4,8,3.4c1.5,0,2.8,1.2,2.9,2.7H11c0.4,0,0.7,0.3,0.7,0.7\n\tL11.8,11.3z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
